import { MAIN_BALANCE } from 'shared/constants/common';
import { Action } from 'shared/interface';
import * as actionTypes from 'shared/store/action-types';
import { getBalanceDetails } from 'shared/util/utility';
import { CpPanel } from '../interface/cpPanel.interface';

const initialState: CpPanel = {
	CpMessages: {
		filter: {
			limit: 10,
			pageNo: 1,
		},
	},
	balanceData: getBalanceDetails() || {
		selectedBalanceType: MAIN_BALANCE,
		mainBalance: null,
		bonusBalance: null,
		bonusBalanceList: [],
	},
	messagesList: [
		{
			messageId: 0,
			dateFrom: '',
			dateTill: '',
			createdAt: '',
			imageAltText: '',
			imageUrl: '',
			primaryButton: {
				link: '',
				text: '',
			},
			title: '',
			isRead: false,
			icon: '',
			isWelcomeMessage: false,
		},
	],
	messagesToDeleteCount: 0,
};

export const CpPanelReducer = (state: CpPanel = initialState, action: Action): CpPanel => {
	switch (action.type) {
		case actionTypes.FETCH_MESSAGES_SUCCESS:
			return {
				...state,
				CpMessages: action.payload,
			};
		case actionTypes.BALANCE_DATA:
			return { ...state, balanceData: action.payload };
		case actionTypes.FETCH_MESSAGES_LIST_SUCCESS:
			return {
				...state,
				messagesList: action.payload,
			};
		case actionTypes.SET_MESSAGES_COUNT_SUCCESS:
			return {
				...state,
				messagesToDeleteCount: action.payload,
			};
		default:
			return state;
	}
};
